export const purchaseHistoryURL = '/myaccount/purchase-history';
export const orderDetailsURL = '/myaccount/order-details';